import React from 'react';

import autoBind from 'react-autobind';
import classNames from 'classnames';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import {
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Checkbox,
  Tooltip,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';

import { pink } from '@material-ui/core/colors'

class DeploymentTable extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      order: 'desc',
      orderBy: 'time_start',
      selected: [],
      page: 0,
      rowsPerPage: 10,
    };
    autoBind(this);
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
    this.state.order = order;
    this.state.orderBy = orderBy;

    this.props.parent.switchSortOrder();
    switch(this.state.orderBy) {
      case "locale_name":
      case "display_name":
        this.props.parent.sortAlphabetDataBy(this.state.orderBy);
        break;
      case "time_from":
      case "time_to":
      case "time_update":
        this.props.parent.sortDateTimeBy(this.state.orderBy);
        break;
      default:
        break;
    }
  }

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState({ selected: this.props.data.map(n => n.id) });
      return;
    }
    this.setState({
      selected: [],
    })
  }

  deselectAll() {
    this.setState({ selected: [] });
    this.state.selected = [];
  }

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
    this.state.selected = newSelected;
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  deletePushDownloadItemClicked() {
    let dialogText = {
      title: Localization.strings.DELETE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deletePushDownloadItemConfirmClicked, this.deletePushDownloadItemCancelClicked);
  }

  deletePushDownloadItemConfirmClicked() {
    let requestObj = {
      "item_id_array": this.state.selected.map(Number),
    };
    this.props.root.refs.API.request("delete_push_download_items", requestObj, this.deletePushDownloadItemOK, this.deletePushDownloadItemFailed);
  }

  deletePushDownloadItemCancelClicked() {

  }

  deletePushDownloadItemOK(res) {
    this.props.root.addNotification(Localization.strings.DELETED);
    this.props.parent.reload();
  }

  deletePushDownloadItemFailed(err) {
    this.props.root.addNotification(Localization.strings.DELETE_FAILED);
  }

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { orderBy, selected, rowsPerPage, page } = this.state;

    return (
      <div>
        <EnhancedTableToolbar
          numSelected={selected.length}
          onDeletePushDownload={this.deletePushDownloadItemClicked}
        />
        <Table>
          <EnhancedTableHead
            numSelected={selected.length}
            order={(this.props.parent.state.sortInAsc? "asc" : "desc")}
            orderBy={orderBy}
            onSelectAllClick={this.handleSelectAllClick}
            onRequestSort={this.handleRequestSort}
            rowCount={this.props.data.length}
          />
          <TableBody>
          {this.props.data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(row => {
              let isSelected = this.isSelected(row['id'])
              return (
                <TableRow
                  hover
                  onClick={event => this.handleClick(event, row['id'])}
                  role="checkbox"
                  key={row['id']}
                  selected={isSelected}
                >
                  <TableCell>
                    <Checkbox checked={isSelected}/>
                  </TableCell>
                  <TableCell>{row['locale_name']}</TableCell>
                  <TableCell>{row['display_name']}</TableCell>
                  <TableCell>{row['time_from'].substring(0, 10)}</TableCell>
                  <TableCell>{row['time_to'].substring(0, 10)}</TableCell>
                  <TableCell>{row['target_username']}</TableCell>
                </TableRow>
              );
            })
          }
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default DeploymentTable;

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

    let rows = [
      { id: 'locale_name', label: Localization.strings.VITALS_NAME },
      { id: 'display_name', label: "Display Name" },
      { id: 'time_from', label: "Start" },
      { id: 'time_to', label: "End" },
    ]

    return (
      <TableHead>
        <TableRow>
          <TableCell>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount && rowCount > 0}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map( row => (
            <TableCell
              key={row.id}
              sortDirection={orderBy === row.id ? order : false}
            >
              <Tooltip
                title={Localization.strings.SORT}
              >
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={this.createSortHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
          <TableCell key={"target_username"}>{Localization.strings.TARGET_USER}</TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

const toolbarStyles = theme => ({
  root: {
    paddingRight: '14px',
  },
  highlight: {
    color: pink["A400"],
    backgroundColor: pink[50],
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: pink["A400"],
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes, onDeletePushDownload } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Button color="secondary" onClick={onDeletePushDownload}>
            <Icon className="buttonIconLeft">delete</Icon>
            {Localization.strings.DELETE}
          </Button>
        ) : (
          ""
        )}
      </div>
    </Toolbar>
  );
}

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);
